import {
	createBrowserRouter,
	createRoutesFromElements,
	LoaderFunction,
	redirect,
	Route,
} from "react-router-dom";
import { Login } from "./components/Login";
import { ESRList } from "./components/ESRList";
import { NotificationsList } from "./components/Notifications";
import { SettingsPage } from "./components/Settings";
import { ESRProjectSummary } from "./components/ESRProjectSummary";
import { ESRForm } from "./components/ESRForm";
import { exchangeOidcCode, getCurrentUser, setCurrentUser } from "./auth";
import { RegisterUserList } from "./components/UsersManagement";
import { OrganizationManagement } from "./components/Organizations/OrganizationManagement";
import { SidebarLayout } from "./components/SidebarLayout";
import {SystemNotifications} from "./components/Notifications/SystemNotifications";
import { ErrorTickets } from "./components/Notifications/ErrorTickets";
import store from "./store";
import { AxiosError } from "axios";
import { HelpPage } from "./components/Help";
import { MessagesList } from "./components/Notifications/MessagesList";

const loader: LoaderFunction = async (args) => {
	const url = new URL(args.request.url);
	const code = url.searchParams.get("code");
	if (code) {
		try {
			const user = await exchangeOidcCode(code);
			setCurrentUser(user);
			store.dispatch({ type: "SET_USER", user });
			return redirect(url.pathname);
		} catch (error) {
			const reason = (error as AxiosError<{ reason: string }>).response?.data.reason ?? "Login failed";
			// /login auto-redirects straight to Keycloak in deployed mode, so a
			// failed callback can't land back there without looping. Surface the
			// error on the sign-up page instead.
			return redirect(`/signup?error=${encodeURIComponent(reason)}`);
		}
	}

	const user = getCurrentUser();
	if (!user) {
		const landingUrl = url.pathname + url.search;
		return redirect(`/login?landing=${encodeURIComponent(landingUrl)}`);
	}
	return {
		user,
	};
};

export const router = createBrowserRouter(
	createRoutesFromElements(
		<>
			<Route path="/login" Component={Login} />
			<Route path="/signup" element={<Login initialMode="signup" />} />
			<Route path="/" Component={SidebarLayout}>
				<Route index loader={loader} Component={NotificationsList} />
				<Route index loader={loader} path="systemnotification" Component={SystemNotifications} />
				<Route index loader={loader} path="errortickets" Component={ErrorTickets} />
				<Route loader={loader} path="all" Component={ESRList} />
				<Route loader={loader} path="messageslist" Component={MessagesList} />
				<Route loader={loader} path="test" element={<ESRList testOnly />} />
				<Route loader={loader} path="test_notifications" element={<NotificationsList testOnly />} />
				<Route loader={loader} path="settings" Component={SettingsPage} />
				<Route loader={loader} path="help" Component={HelpPage} />
				<Route
					loader={loader}
					path="esr/:esrId/:activeLabel/:activeId"
					Component={ESRProjectSummary}
				/>
				<Route
					loader={loader}
					path="esr/:esrId/:activeLabel/:activeId/redirect/:questionId"
					Component={ESRForm}
				/>
				<Route
					loader={loader}
					path="esr/:esrId/:activeLabel/:activeId/:groupIdx/:questionId?"
					Component={ESRForm}
				/>
				{/*TODO: This endpoint needs to be accessible only to permitted users*/}
				<Route
					loader={loader}
					path="usersmanagement"
					Component={RegisterUserList}
				/>
				<Route
					loader={loader}
					path="organizations"
					Component={OrganizationManagement}
				/>
			</Route>
		</>,
	),
);